import { Pipe, PipeTransform } from '@angular/core'
import { convert } from '../bridges/frontend-text-bridge.js'

@Pipe({
	name: 'base64',
	standalone: false,
})
export class Base64Pipe implements PipeTransform {
	transform(data: string | ArrayBuffer): string {
		if (data instanceof ArrayBuffer) {
			return convert(data, 'binary', 'base64')
		}
		return data
	}
}
